<template>
  <div class="logo-layout" :class="{'horizontal': isHorizontal}">
    <div class="logo-container" :class="{isNotMine}">
      <div class="logo-wrap" v-if="!isABPlan">
        <div class="logo" >
          <template v-if="layout.lnbMinimize">
            <i class="icon icon--logo-white-min" :class="{'white': isLogoWhite}" @click="toDashboard"></i>
          </template>
          <template v-else>
            <i class="icon icon--logo-new" :class="{'white': isLogoWhite}" @click="toDashboard"></i>
            <div class="map-logo" @click="onClickHeatmapLogo" :class="{'white': isLogoWhite}">
              <i class="icon icon--logo-new-heatmap-red" :class="{'white': isLogoWhite}">
                <i class="icon icon--logo-new-side" :class="{'white': isLogoWhite}" />
              </i>
            </div>
          </template>
        </div>

        <template v-if="isOpenMapChanger">
          <div class="map-change-wrap"  @mouseleave="onCloseMapChanger">
            <div
              class="map heatmap active"
              @click="toDashboard"
            >
              <i
                class="icon icon--logo-new-heatmap-red white"
              />
            </div>
            <div class="journeymap map"
                 @click="toJourneymap">
              <i
                class="icon icon--logo-new-journeymap-red"
              />
            </div>
            <div class="geo map"
                 @click="toGeo">
              <i
                class="icon icon--logo-new-geo-red"
              />
            </div>
          </div>
        </template>
      </div>

      <h1 v-else class="report__menu--logo" :class="[target, {'black' : isLogoWhite && isABPlan && target !== 'report'}]">
        <router-link :to="{ name: 'home' }">
          <i class="icon icon--logo-white-min"></i>
          <i v-if="isLogoWhite" class="icon icon--logo-beusable-only-white"></i>
          <i v-else class="icon icon--logo-new"></i>

          <i class="icon icon-x"></i>
          <i class="icon company" :class="companyName"></i>

          <i v-if="target === 'report' && applyData.bAMP" class="icon icon--amp-logo"></i>
        </router-link>
        <i class="icon icon--abplan--logo" v-if="isABPlan"></i>
      </h1>
    </div>

    <mine-button v-if="!isEditMode && !isAiDisabled && $route.name === 'dashboard'" :isDisabled="totalReportCnt <= 0"/>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { BA_URL, GEO_URL, isAiDisabledAccount } from '@/libs/utils'
import MineButton from '@/components/mine/MineButton.vue'

export default {
  components: { MineButton },
  props: {
    target: {
      type: String,
      default: 'report'
    },
    isEditMode: {
      type: Boolean,
      default: false
    },
    isHorizontal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpenMapChanger: false
    }
  },
  methods: {
    ...mapActions(['storeMineCnt']),

    toGeo () {
      window.location.href = GEO_URL
    },
    toDashboard () {
      if (this.$route.name !== 'dashboard') {
        setTimeout(() => {
          this.$router.push({ name: 'dashboard' })
        }, 300)
      } else {
        location.href = '/dashboard'
      }
    },
    toJourneymap () {
      window.location.href = BA_URL
    },
    onClickHeatmapLogo () {
      this.isOpenMapChanger = true
    },
    onCloseMapChanger () {
      this.isOpenMapChanger = false
    }
  },
  computed: {
    ...mapState([
      'layout',
      'applyData',
      'userData',
      'isABPlan',
      'totalReportCnt'
    ]),
    isAiDisabled () {
      return isAiDisabledAccount(this.userData)
    },
    companyName () {
      if (this.userData.userId.indexOf('wirelink') > -1) {
        return 'wirelink'
      }
      return 'siemens'
    },
    isLogoWhite () {
      return this.target === 'report' || this.companyName === 'wirelink'
    },
    isNotMine () {
      return this.$route.name !== 'mine'
    }
  },
  created () {
    if (this.$route.name === 'dashboard' || this.$route.name === 'mine' || this.$route.name === 'heatmap-report') { this.storeMineCnt(this.$i18n.locale) }
  }
}
</script>
<style lang="scss" scoped>
.logo-layout {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0;
  width: 100%;
  box-sizing: border-box;

  .logo-container.isNotMine {
    padding: 15px 8px 10px;
  }

  &.horizontal {
    padding: 0;

    .logo-wrap {
      padding: 0
    }

    .logo {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      gap: 12px;
    }

    .map-logo {
      padding: 0;
      margin: 0;
      position: relative;
      &:not(.only-logo) {
        &:hover {
          border-radius: 0;
          background: initial;
          &:before {
            content: '';
            width: calc(100% + 8px);
            height: calc(100% + 8px);
            position: absolute;
            bottom: -4px;
            left: -8px;
            background: rgba(0, 0, 0, 0.06);
            border-radius: 6px;
          }
        }
      };
    }

    .map-change-wrap {
      left: 121px;
    }
  }
}

.logo-wrap {
  display: inline-block;
  position: relative;
  padding: 0 6px;
}

.logo {
  vertical-align: top;
  display: inline-block;
  flex-direction: column;
  position: relative;
  z-index: 10;
  cursor: pointer;
  width: 112px;

  & .icon--logo-new {
    display: inline-block;
  }

  & .map-logo {
    width: 111px;
    height: 16px;
    padding: 4px;
    margin: 4px 0 0 -4px;

    &:not(.only-logo) {
      &:hover {
        border-radius: 6px;
        background: rgba(0, 0, 0, 0.06);
      }
    }

    & .icon--logo-new-heatmap-red {
      display: inline-block;
      position: relative;
    }

    & .icon--logo-new-side {
      right: -10px;
      bottom: 2px;
      position: absolute;
    }

    &.white {
      &:hover {
        background: rgba(255, 255, 255, 0.06);
      }
    }
  }
}

.map-change-wrap {
  display: inline-block;
  position: absolute;
  top: -5px;
  left: 0;
  width: 120px;
  height: 104px;
  z-index: 100;
  cursor: pointer;
  box-shadow: 0 8px 14px -2px rgba(0, 0, 0, 0.08);

  .map {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    box-sizing: border-box;
    height: calc(100% / 3);
    transition: all 0.2s ease-in-out;

    &:not(.active):hover {
      background: #ebebeb;
    }

    &.active {
      background: #ec0047;
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.35) inset;
      border: none;
    }
  }

  .heatmap {
    border-radius: 6px 6px 0 0;
    border-top: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;
    border-left: 1px solid #e0e0e0;
  }

  .journeymap {
    border-radius: 0;
    border-right: 1px solid #e0e0e0;
    border-left: 1px solid #e0e0e0;
    border-top: 1px solid #e0e0e0;
  }

  .geo {
    border-radius: 0 0 6px 6px;
    border-top: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
    border-left: 1px solid #e0e0e0;
  }
}

 /* ab test */
.report__menu--logo {
  position: relative;
  margin-top: 15px;
  margin-left: 15px;
  white-space: nowrap;

  &.black {
    background-color: #1b1b1b;
    width: 180px;
    margin-top: 5px;
    margin-left: 5px;
    padding: 10px;
    border-radius: 5px;
  }

  &.report {
    margin-top: 18px;
    margin-left: 18px;

    &.black {
      width: 160px;
    }
  }

  a {
    display: block;
    .icon--logo-white-min {
      position: absolute;
      top: 0px;
      left: 0px;
      opacity: 0;
    }

    h2 {
      margin-top: 5px;
      font-family: "rubrik-new";
      font-size: 14px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1;
      letter-spacing: -0.22px;
      color: #ec0047;

      &.white {
        color: #ffffff;
      }
    }
  }

  .icon--abplan--logo {
    display: inline-block;
    margin-top: 8px;
  }

  .icon-x {
    display: inline-block;
    margin-left: 8px;
    width: 20px;
    height: 20px;
  }

  .company {
    display: block;

    margin-top: 5px;
    &.wirelink {
      width: 132px;
      height: 29px;
      background-size: 132px;
      background-image: url(../../assets/img/abplan/logo_wirelink.png);
      margin-left: -6px;
    }

    &.siemens {
      width: 132px;
      height: 29px;
      background-size: 132px;
      background-image: url(../../assets/img/abplan/siemens.svg);
    }
  }
}
</style>
